import { ChainId } from '@nominex/nomiswap-sdk'
import chunk from 'lodash-es/chunk'
import stakingServiceAbi from 'config/abi/IStakingServiceContract.json'
import { SerializedFarmConfig } from 'config/farms'
import { SerializedFarm } from 'state/types'
import multicall from 'utils/multicall'

function mapCalls(farm: SerializedFarm) {
  return [
    {
      address: farm.stakingServiceAddress,
      name: 'totalStaked',
    },
  ]
}

export const fetchStakingServiceData = async (farms: SerializedFarmConfig[], chainId: ChainId): Promise<any[]> => {
  const calls = farms.flatMap(mapCalls)
  const chunkSize = calls.length / farms.length
  const multicallResult = await multicall(stakingServiceAbi, calls, chainId)

  return chunk(multicallResult, chunkSize)
}
